
//Types should be in const to avoid typos and duplication since it's a string and could be easily misspelt
export const ADD_TO_CART = 'ADD_TO_CART';
export const REMOVE_ITEM = 'REMOVE_ITEM';
export const SUB_QUANTITY = 'SUB_QUANTITY';
export const ADD_QUANTITY = 'ADD_QUANTITY';
export const ADD_SHIPPING = 'ADD_SHIPPING';
export const UPDATE_ITEMS = 'UPDATE_ITEMS';
export const CLEAR_CART = 'CLEAR_CART';
